import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface OrganizationCardProps {
  name: string;
  description?: string | null;
  location?: string | null;
  website?: string | null;
}

export const OrganizationCard = ({ name, description, location, website }: OrganizationCardProps) => {
  return (
    <Card className="hover:shadow-lg transition-shadow">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">{name}</CardTitle>
        </div>
        {location && (
          <p className="text-sm text-muted-foreground">{location}</p>
        )}
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-4">
          {description || 'No description provided'}
        </p>
        {website && (
          <a
            href={website}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary hover:underline"
          >
            Visit Website
          </a>
        )}
      </CardContent>
    </Card>
  );
};